<template>
  <LoadContainer/>
  <NavBar/>
  <NuxtPage/>
  <Footer/>
</template>
